import { useGetStartedAccess } from './composables/useGetStartedAccess'

/** Capture the shared access answer once; the returned provider stays reactive per read. */
export function createGetStartedNavItemsProvider() {
  const access = useGetStartedAccess()
  return () => {
    if (!access.available.value) return []
    return [
      {
        labelKey: 'globalSurface.getStarted.nav',
        icon: 'rocket-launch',
        navKey: 'getStarted',
        to: { name: 'GetStarted' },
      },
    ]
  }
}
